import amplitude from 'amplitude-js';
import { getRecipientTypeParam, transactionMethods } from 'apps/auth/components/utils/AmplitudeUtils';
import { DELIVERY_METHOD_SELECTED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import {
    PAYMENT_FLOW,
    PAYOUT_COUNTRY,
    PAYOUT_CURRENCY,
    PAYOUT_METHOD,
    PAYOUT_METHOD_CATEGORY,
    RECIPIENT_TYPE,
    TRANSFER_COUNT,
} from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { NEW } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import {
    DELIVERY_ALIPAY,
    DELIVERY_BANK_ACCOUNT,
    DELIVERY_BANK_CARD,
    DELIVERY_CASH,
    DELIVERY_CASH_UNITELLER,
    DELIVERY_CONTACT,
    DELIVERY_HOME,
    DELIVERY_INTERAC,
    DELIVERY_LIBRE_PAYSEND_LIVE,
    DELIVERY_MOBILE,
    DELIVERY_REMITEE,
    DELIVERY_SEPA,
    DELIVERY_SWIFT,
    DELIVERY_UNITELLER_MASTERCARD_BANK_CARD,
    DELIVERY_UPI,
    DELIVERY_VIA_PHONE_NUMBER,
    DELIVERY_VISA_BANK_CARD,
    DELIVERY_WALLET,
    DELIVERY_WECHAT,
    DELIVERY_PEOPLE_TRUST_INTERAC,
    DELIVERY_UNIONPAY_BANK_CARD,
    DELIVERY_GCASH_WALLET,
} from 'apps/auth/constants/Constants';
import { AUTH, AUTH_GA_POCKET, PROFILE_BONUS_WITHDRAW, SEND } from 'apps/auth/constants/UrlConstants';
import { toLowerCase } from 'apps/auth/helpers/utils';

export const amplitudeEvent = (
    isGA = false,
    toCountryName,
    deliveryMethod = DELIVERY_BANK_CARD,
    recipientType,
    toCurrencyCode,
    payoutMethodCategory = '',
    transferCount,
) => {
    if (!isGA) {
        amplitude.getInstance().logEvent(DELIVERY_METHOD_SELECTED, {
            [PAYOUT_COUNTRY]: toCountryName,
            [PAYOUT_METHOD]: transactionMethods[deliveryMethod],
            [PAYMENT_FLOW]: NEW,
            [RECIPIENT_TYPE]: getRecipientTypeParam(recipientType),
            [PAYOUT_CURRENCY]: toCurrencyCode,
            [PAYOUT_METHOD_CATEGORY]: payoutMethodCategory,
            [TRANSFER_COUNT]: transferCount !== 'no_value' ? transferCount : null,
        });
    }
};
export const getHref = (deliveryMethod = DELIVERY_BANK_CARD, toCountryCode, toCurrencyCode, pocketId, isGA = false, isBonus = false, sendUriPostfix) => {
    const href = isGA ? `${AUTH_GA_POCKET}${pocketId}` : AUTH;
    const path = isBonus ? PROFILE_BONUS_WITHDRAW : SEND;
    const deliveryMethodLink = `${path}/${toLowerCase(toCountryCode)}/${toLowerCase(toCurrencyCode)}/${deliveryMethod}${sendUriPostfix}`;
    return `${href}${deliveryMethodLink}`;
};
export const deliveryIcon = (deliveryMethod, toCountryCode) => {
    if (deliveryMethod === DELIVERY_CONTACT) {
        return 'person';
    }
    if (deliveryMethod === DELIVERY_BANK_ACCOUNT || deliveryMethod === DELIVERY_SEPA || deliveryMethod === DELIVERY_REMITEE) {
        return 'bank';
    }
    if (deliveryMethod === DELIVERY_SWIFT) {
        return 'globe';
    } else if (
        deliveryMethod === DELIVERY_BANK_CARD ||
        deliveryMethod === DELIVERY_VISA_BANK_CARD ||
        deliveryMethod === DELIVERY_UNIONPAY_BANK_CARD ||
        deliveryMethod === DELIVERY_UNITELLER_MASTERCARD_BANK_CARD
    ) {
        return 'card';
    } else if (deliveryMethod === DELIVERY_ALIPAY) {
        return 'alipay';
    } else if (deliveryMethod === DELIVERY_INTERAC) {
        return 'interac';
    } else if (deliveryMethod === DELIVERY_PEOPLE_TRUST_INTERAC) {
        return 'bank';
    } else if (deliveryMethod === DELIVERY_CASH || deliveryMethod === DELIVERY_CASH_UNITELLER || deliveryMethod === DELIVERY_HOME) {
        return 'cash-stack';
    } else if (deliveryMethod === DELIVERY_WALLET && toCountryCode === 'pk') {
        return 'mobile';
    } else if (deliveryMethod === DELIVERY_VIA_PHONE_NUMBER) {
        return 'mobile';
    } else if (deliveryMethod === DELIVERY_WALLET) {
        return 'wallet';
    } else if (deliveryMethod === DELIVERY_UPI) {
        return 'upi';
    } else if (deliveryMethod === DELIVERY_MOBILE) {
        return 'mobile';
    } else if (deliveryMethod === DELIVERY_WECHAT) {
        return 'wechat';
    } else if (deliveryMethod === DELIVERY_LIBRE_PAYSEND_LIVE) {
        return 'paysend-rounded';
    } else if (deliveryMethod === DELIVERY_GCASH_WALLET) {
        return 'g-cash';
    }
};
